<template>
  <div>
    <div>句子翻译</div>

    <div class="list">
      <div v-for="item in config.list" :key="item.id">
        {{item.sentence_id}} {{item.text}}
      </div>
    </div>

    <div class="pre-wrap">进入消息: {{config.enter_msg}}</div>
    <div class="pre-wrap">需要确认: {{config.enter_ready}}</div>
    <div class="pre-wrap">第一条消息: {{config.first_msg}}</div>
    <div class="pre-wrap">下一个消息: {{config.next_msg}}</div>
    <div class="pre-wrap">完成模块消息: {{config.finish_msg || '无'}}</div>
    <SttFormat :formats="config.stt_format"/>
    <TtsFormat :formats="config.tts_format"/>

  </div>
</template>

<script>
import SttFormat from "./stt_format.vue";
import TtsFormat from "./tts_format.vue";

export default {
  name: "ai_sentence_order",
  components: {TtsFormat,SttFormat},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
}
</script>

<style scoped>
.list > div {
  padding: 0 10px;
}
</style>